var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoresults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 69,
    viewBox: "0 0 130 69",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-noresults_svg__Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-noresults_svg__Layout-\\u2013-Live-\\u2013-No-Results-\\u2013-Desktop",
    transform: "translate(-654 -246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-noresults_svg__Empty",
    transform: "translate(435 246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-noresults_svg__Group-5",
    transform: "translate(219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-noresults_svg__Stars",
    transform: "matrix(-1 0 0 1 130 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.805 34.687c0-.702.574-1.272 1.28-1.272.708 0 1.28.57 1.28 1.272 0 .703-.572 1.273-1.28 1.273-.706 0-1.28-.57-1.28-1.273",
    id: "icon-noresults_svg__Fill-2-Copy-2",
    fill: "#CFE0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 1.273C18 .57 18.574 0 19.28 0c.708 0 1.281.57 1.281 1.273s-.573 1.273-1.28 1.273c-.707 0-1.281-.57-1.281-1.273",
    id: "icon-noresults_svg__Fill-2-Copy-3",
    fill: "#CFE0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.561 47.092A2.558 2.558 0 0013 44.546 2.558 2.558 0 0015.561 42a2.559 2.559 0 002.561 2.546 2.559 2.559 0 00-2.561 2.546z",
    id: "icon-noresults_svg__Stroke-4",
    fill: "#1A2E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.516 55.078c-.31-1.925-1.406-3.089-3.446-3.425a.08.08 0 010-.158c2.112-.347 3.137-1.5 3.446-3.425a.08.08 0 01.159 0c.309 1.925 1.299 3.114 3.446 3.425.094.014.093.142 0 .158-2.093.336-3.137 1.5-3.446 3.425a.08.08 0 01-.16 0",
    id: "icon-noresults_svg__Fill-10-Copy",
    fill: "#8498A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-noresults_svg__Fill-12",
    fill: "#1A2E3B",
    d: "M127.5 26l.625 1.875L130 28.5l-1.875.625L127.5 31l-.625-1.875L125 28.5l1.875-.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.977 47.875a.822.822 0 010 1.166.834.834 0 01-1.173 0 .822.822 0 010-1.166.834.834 0 011.173 0",
    id: "icon-noresults_svg__Fill-18-Copy-2",
    fill: "#1A2E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.342 40.485a.822.822 0 010 1.166.834.834 0 01-1.173 0 .822.822 0 010-1.166.834.834 0 011.173 0",
    id: "icon-noresults_svg__Fill-18-Copy",
    fill: "#CFE0ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-noresults_svg__Fill-1",
    fill: "#CFE0ED",
    d: "M120.162 8.176l-3.502 1.169 3.502 1.168 1.168 3.503 1.168-3.503L126 9.345v-.001l-3.502-1.168-1.168-3.504z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.277 25.193c0-3.238-2.64-5.88-5.877-5.88 3.237 0 5.877-2.642 5.877-5.88 0 3.238 2.64 5.88 5.877 5.88-3.236 0-5.877 2.642-5.877 5.88z",
    id: "icon-noresults_svg__Stroke-4",
    fill: "#EEF1F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-noresults_svg__Fill-11",
    fill: "#CFE0ED",
    d: "M106.144 38l.759 1.386 1.385.759-1.385.758-.759 1.386-.757-1.386-1.386-.758 1.386-.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.123 20.565a1.752 1.752 0 113.505 0 1.752 1.752 0 01-3.505 0",
    id: "icon-noresults_svg__Fill-2",
    fill: "#8498A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.164 15.76c0-3.238-2.64-5.88-5.877-5.88 3.237 0 5.877-2.642 5.877-5.88 0 3.238 2.64 5.88 5.877 5.88-3.237 0-5.877 2.642-5.877 5.88z",
    id: "icon-noresults_svg__Stroke-4",
    fill: "#EEF1F2"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "icon-noresults_svg__Oval-2",
    fill: "#8498A4",
    fillRule: "nonzero",
    cx: 66.146,
    cy: 34.146,
    r: 34.146
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-noresults_svg__Eyeglass",
    transform: "translate(53 21)",
    stroke: "#1A2E3B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icon-noresults_svg__Oval",
    cx: 11.012,
    cy: 11.012,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 20l6.83 6.83",
    id: "icon-noresults_svg__Path-10",
    strokeLinecap: "round"
  }))))))));
}
export default SvgIconNoresults;